export default "__VITE_ASSET__CvV9lNUh__"